import { RootState } from "@/@types/store";
import { emitter, SYS_ELE_BIND } from "@/plugin/emitter";
import { actionTypes, mutationTypes } from "@/store/types";
import { ElMessage, ElMessageBox } from "element-plus";
import { h } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export function useBind(message: string, isJump?: boolean) {
    const store = useStore<RootState>();
    const router = useRouter();

    const handleBind = async (callback?: (...args: any) => void) => {
        await store.dispatch(`user/${actionTypes.GET_USER_INFO}`)
        const bindElcSheet = store.state.user.userInfo.bindElcSheet;
        if (!bindElcSheet) {
          if (store.state.user.userInfo.menuRoleInfoCO.queryUserExist.master) {
            if (isJump) {
              store.commit(`config/${mutationTypes.SET_NAV_TAB_LIST}`, { action: 'REMOVE_LAST' })
              await router.replace({
                path: '/admin/base-setting/bes-manager/bes-list'
              })
              emitter.emit(SYS_ELE_BIND)
              return
            }
            ElMessageBox({
              type: "warning",
              boxType: "confirm",
              message: h("div", null, [
                h("div", null, message),
                h("div", null, [
                  h("span", null, "无电子面单账号？"),
                  h(
                    "span",
                    {
                      style: "cursor: pointer;color: #0068f9",
                      onclick() {
                        ElMessageBox.close();
                        router.replace({
                          name: "/admin/base-setting/bes-manager/bes-list",
                          params: {
                            showApplyElcSheet: 1,
                          },
                        });
                      },
                    },
                    "去申请"
                  ),
                ]),
              ]),
              title: "未绑定电子面单账号",
              showCancelButton: true,
              cancelButtonText: "取消",
              confirmButtonText: "去绑定",
            }).then(() =>
              router.replace({
                name: "/admin/base-setting/bes-manager/bes-list",
                params: {
                  showBindElcSheet: 1,
                },
              })
            );
          } else {
            ElMessage.warning("尚未关联电子面单账号，请联系主账号");
          }
          return;
        } else {
            callback && callback()
        }
    }

    return {
        handleBind
    }
}